import { useState } from 'react'

import { useEffect } from 'modules/core/hooks/useEffect'

import { useHapiElementsContext } from 'modules/ats/components/HapiElementsLoader'
import type { Contract } from 'modules/ats/lib/vonq'

export const useGetImportedContracts = () => {
  const { elementsLoaded } = useHapiElementsContext()
  const [loading, setLoading] = useState(false)
  const [importedContracts, setImportedContracts] = useState<Contract[]>([])

  useEffect(() => {
    if (!elementsLoaded) {
      return
    }

    async function fetchData() {
      const response = await window.hapi.contract.service?.getContracts.run(0)

      if (!response) {
        return
      }

      setImportedContracts(response.results)
    }

    fetchData()

    window.hapi.contract.state?.contractsAreLoading.onChange((newValue: boolean) => {
      setLoading(newValue)
    })

    window.hapi.contract.state?.contracts.onChange((newValue: Contract[]) => {
      setImportedContracts(newValue)
    })
  }, [elementsLoaded])

  return { loading, importedContracts }
}
